import React from 'react';
import { Badge } from '../../../../../CommonComponents/OPL/Badge/Badge';

interface Props {
  riskScore: number | null;
}

export const RiskScoreBadge: React.FC<Props> = ({ riskScore }) => {
  return (
    <Badge variant={riskScore === null ? 'tertiary' : 'secondary'}>
      {riskScore === null ? '--' : riskScore}
    </Badge>
  );
};
